module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.username
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "nom d'utilisateur"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.logIn($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), (_vm.errors.username) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.username[0]))]) : _vm._e()]), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.email
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "email (optionnel)"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.register($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), (_vm.errors.email) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.email[0]))]) : _vm._e()]), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.password
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "mot de passe"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.register($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), (_vm.errors.password) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.password[0]))]) : _vm._e()]), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.errors.passwordConfirmation
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "confirmation mot de passe"
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.register($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  })]), (_vm.errors.passwordConfirmation) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(" " + _vm._s(_vm.errors.passwordConfirmation[0]))]) : _vm._e()]), _c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("valider l'inscription")]), (_vm.errors.server) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.server[0]))]) : _vm._e(), _c('button', {
    staticClass: "btn btn-block btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('switch-to-connection')
      }
    }
  }, [_vm._v("retourner à la connexion")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-227bcb03!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/RegistrationForm.vue
// module id = 586
// module chunks = 2